import React, { lazy, Suspense, useLayoutEffect } from "react";
import "@/App.css";
import "@/components/works/works.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { LanguageProvider, useLanguage } from "@/context/LanguageContext";
import { ClickEffect } from "@/components/ClickEffect";
import { CookieConsent } from "@/components/landing/CookieConsent";
import { langBase } from "@/lib/basePath";

const ArcadeHome = lazy(() => import("@/pages/ArcadeHome"));
const LandingPage = lazy(() => import("@/pages/LandingPage"));
const OurStoryPage = lazy(() => import("@/pages/OurStoryPage"));
const BlogArticlePage = lazy(() => import("@/pages/BlogArticlePage"));
const JarvisCompanyPage = lazy(() => import("@/pages/JarvisCompanyPage"));
const SavingsPage = lazy(() => import("@/pages/SavingsPage"));
const QuizzPage = lazy(() => import("@/pages/QuizzPage"));
const ConfidentialitePage = lazy(() => import("@/pages/ConfidentialitePage"));
const MentionsLegalesPage = lazy(() => import("@/pages/MentionsLegalesPage"));
const CGVPage = lazy(() => import("@/pages/CGVPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

function RouteBrand() {
  const { pathname } = useLocation();
  const { lang } = useLanguage();
  const works = pathname.toLowerCase().startsWith('/100xworks');
  useLayoutEffect(() => {
    document.documentElement.classList.toggle('works-page', works);
    document.documentElement.lang = lang;
    return () => document.documentElement.classList.remove('works-page');
  }, [works, lang]);
  return works ? null : <ClickEffect />;
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter basename={langBase() || "/"}>
            <RouteBrand />
            <Suspense fallback={<div style={{ minHeight: "100vh", background: "#08080A" }} />}>
              <Routes>
                {/* The Jarvis Company umbrella site */}
                <Route path="/" element={<ArcadeHome />} />

                {/* 100xWorks product (kept under /100xWorks, unchanged URLs) */}
                <Route path="/100xWorks" element={<LandingPage />} />
                <Route path="/100xWorks/notre-histoire" element={<OurStoryPage />} />
                <Route path="/100xWorks/the-jarvis-company" element={<JarvisCompanyPage />} />
                <Route path="/100xWorks/blog/:slug" element={<BlogArticlePage />} />
                <Route path="/100xWorks/savings" element={<SavingsPage />} />
                <Route path="/100xWorks/quizz" element={<QuizzPage />} />
                <Route path="/100xWorks/confidentialite" element={<ConfidentialitePage />} />
                <Route path="/100xWorks/mentions-legales" element={<MentionsLegalesPage />} />
                <Route path="/100xWorks/cgv" element={<CGVPage />} />

                {/* Anything else: a real « page not found » (nginx serves its
                    prerendered copy with a 404 status; the retired /soft and
                    /v1 preview routes are redirected to the homepage there). */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
            <CookieConsent />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
